import apiClient from "../api/apiClient";
import { endPoints } from "../config/endpoints";

export const securityService = {
  async getAuthFailuresAsync(params) {
    const response = await apiClient.get(endPoints.security.getAuthFailures, {
      params,
    });
    return response.data;
  },
};
